export default __webpack_public_path__ + "static/media/engineer.816c61a0.jpg";